"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBookAppointmentStore = void 0;
const pinia_1 = require("pinia");
const appLoginStore_1 = require("../appLogin/appLoginStore");
const appointmentStore_1 = require("../../stores/appointment/appointmentStore");
//import { Router } from "vue-router";
const i18n_1 = __importDefault(require("../../common/i18n"));
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useBookAppointmentStore = (0, pinia_1.defineStore)("bookAppointmentStore", {
    state: () => ({
        carDatas: {
            licencePlate: "",
            carBrand: "",
            carModel: "",
            carYearOfProduction: 0,
            carEngine: "",
            carBrandSlug: "",
            carModelSlug: "",
            carEngineSlug: "",
        },
        tyreDatas: {
            tyreDiameter: 0,
            isWheel: null,
            isTpms: false,
            isRunflat: false,
            isStored: false, // tárolt gumiabroncs
        },
        personDatas: {
            name: "",
            phoneNumber: "",
            GDPR: false,
        },
        email: "",
        reservedServiceLocationId: null,
        tyreFittingServiceSKU: null,
        serviceBay: null,
        bookDate: "",
        bookTime: "", // formátum hh::mm:ss
    }),
    getters: {},
    actions: {
        async saveAppointment() {
            var _a;
            const error = this.validateData();
            if (error) {
                throw new Error(error);
            }
            else {
                const appLoginStore = (0, appLoginStore_1.useAppLoginStore)();
                this.email = (_a = appLoginStore.authenticatedUser) === null || _a === void 0 ? void 0 : _a.email;
                return new Promise((resolve, reject) => {
                    (0, fetch_1.default)("/api/appointment/save", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(this.$state),
                    })
                        .then((response) => {
                        if (typeof response.error !== "undefined") {
                            // refresh failed
                            if (response.error == "No Appointment found!") {
                                const appointmentsStore = (0, appointmentStore_1.useAppointmentStore)();
                                appointmentsStore.reload = true;
                                reject(i18n_1.default.trans("frontend_book_error", "The date you have chosen is booked, please choose another date!", "frontend"));
                            }
                            reject(i18n_1.default.trans("frontend_book_error", "Can't save the appointment! Try Again later!", "frontend"));
                            return;
                        }
                        resolve();
                    })
                        .catch((error) => {
                        reject(error);
                    });
                });
            }
        },
        validateData() {
            if (!this.carDatas.licencePlate) {
                return i18n_1.default.trans("frontend_licensplate_error", "License plate is required!", "frontend");
            }
            if (!this.carDatas.carBrand) {
                return i18n_1.default.trans("frontend_carBrand_error", "Car brand is required!", "frontend");
            }
            if (!this.carDatas.carYearOfProduction) {
                return i18n_1.default.trans("frontend_car_year_error", "Car year is required!", "frontend");
            }
            if (!this.carDatas.carModel) {
                return i18n_1.default.trans("frontend_car_model_error", "Car model is required!", "frontend");
            }
            if (!this.carDatas.carEngine) {
                return i18n_1.default.trans("frontend_car_engine_error", "Car engine is required!", "frontend");
            }
            if (!this.tyreDatas.tyreDiameter) {
                return i18n_1.default.trans("frontend_tyre_diameter_error", "Tyre diameter is required!", "frontend");
            }
            if (this.tyreDatas.isWheel === null) {
                return i18n_1.default.trans("frontend_tyre_wheel_error", "Tyre wheel is required!", "frontend");
            }
            if (!this.personDatas.GDPR) {
                return i18n_1.default.trans("frontend_gdpr_error", "GDPR is required!", "frontend");
            }
            if (!this.personDatas.name) {
                return i18n_1.default.trans("frontend_name_error", "Name is required!", "frontend");
            }
            if (!this.personDatas.phoneNumber) {
                return i18n_1.default.trans("frontend_phone_number_error", "Phone number is required!", "frontend");
            }
            if (!this.reservedServiceLocationId) {
                return i18n_1.default.trans("frontend_phone_number_error", "Location is required!", "frontend");
            }
            if (!this.tyreFittingServiceSKU) {
                return i18n_1.default.trans("frontend_fitting_service_error", "Tyre fitting service is required!", "frontend");
            }
            if (!this.bookDate) {
                return i18n_1.default.trans("frontend_booking_date_error", "Booking date is required!", "frontend");
            }
            if (!this.bookTime) {
                return i18n_1.default.trans("frontend_booking_time_error", "Booking time is required!", "frontend");
            }
        },
    },
});
